import { render, staticRenderFns } from "./ProgramActivityLevelListFilter.vue?vue&type=template&id=0970a056&scoped=true"
import script from "./ProgramActivityLevelListFilter.vue?vue&type=script&lang=js"
export * from "./ProgramActivityLevelListFilter.vue?vue&type=script&lang=js"
import style0 from "./ProgramActivityLevelListFilter.vue?vue&type=style&index=0&id=0970a056&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/cli-service/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "0970a056",
  null
  
)

export default component.exports